import React from 'react';

function MultiOptionsQuestion({ question, value = { answer: [], otherAnswer: '' }, onChange, disabled = false }) {
  // Handle checkbox changes
  const handleChange = (optionText, checked) => {
    let newAnswers;
    if (checked) {
      newAnswers = [...(value.answer || []), optionText];
    } else {
      newAnswers = (value.answer || []).filter(item => item !== optionText);
    }
    
    // Return both the updated answers array and the existing otherAnswer
    onChange({ 
      answer: newAnswers, 
      otherAnswer: value.otherAnswer || '' 
    });
  };

  // Handle the "More" text input change
  const handleMoreChange = (e) => {
    onChange({ 
      answer: value.answer || [], 
      otherAnswer: e.target.value 
    });
  };

  return (
    <div className="space-y-4">
      {question.options.map((option, index) => (
        <label 
          key={index} 
          className={`flex items-center p-3 rounded-lg transition-all duration-200 ${
            (value.answer || []).includes(option) 
              ? 'bg-blue-50 border border-blue-200 shadow-sm' 
              : 'hover:bg-gray-50 border border-transparent'
          } ${disabled ? 'opacity-70 cursor-not-allowed' : 'cursor-pointer'}`}
        >
          <input
            type="checkbox"
            name={`question-${question.id}`}
            value={option}
            checked={(value.answer || []).includes(option)}
            onChange={(e) => handleChange(option, e.target.checked)}
            className="form-checkbox h-5 w-5 text-blue-600 rounded focus:ring-blue-500"
            disabled={disabled}
          />
          <span className={`ml-3 text-gray-800 ${(value.answer || []).includes(option) ? 'font-medium' : ''}`}>
            {option}
          </span>
        </label>
      ))}
      
      {/* More text input field */}
      <div className="mt-6 p-4 border border-gray-200 rounded-lg bg-gray-50">
        <label className="flex flex-col w-full">
          <span className="text-gray-800 mb-3 font-medium text-lg">Other input:</span>
          <input
            type="text"
            value={value.otherAnswer || ''}
            onChange={handleMoreChange}
            className="form-input rounded-md border-gray-300 shadow-sm focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50 py-3 px-4 text-base w-full"
            placeholder="Enter alternative or additional input..."
            disabled={disabled}
          />
        </label>
      </div>
    </div>
  );
}

export default MultiOptionsQuestion;
